import { useGLTF } from '@react-three/drei';
import * as global from "../../data/global";

export function An3(props) {
    const { nodes } = useGLTF('3ds/an/An3.gltf');
    return (
        <group {...props} dispose={null}>
            <mesh
                ref={e => {
                    if (!e) return;
                    if (!global.gw.geometries.An3) {
                        global.gw.geometries.An3 = e.geometry;
                    }
                }}
                name="An3"
                geometry={nodes.An3.geometry}
                rotation={[Math.PI / 2, 0, 0]}
                {...props.meshProps}
            />
        </group>
    );
}

useGLTF.preload('3ds/an/An3.gltf');
